import {makeStyles} from "@material-ui/core";
import type {DetailedHTMLProps, ImgHTMLAttributes} from "react";
import React from 'react';
import TimeVarianceAuthorityPng from '../TimeVarianceAuthority.png';

const useStyles = makeStyles(theme => ({
    grow: {
        transition: 'all .2s ease-in-out',
        "&:hover": {
            transform: 'scale(2)',
        }
    },
}));

const TimeVarianceAuthority = (props : DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) => {
    const styles = useStyles();
    return <img
        src={TimeVarianceAuthorityPng}
        className={styles.grow}
        {...props}
    />
}

export default TimeVarianceAuthority;
